import React from 'react'
import { ChakraProvider, Box, Text, Stack } from '@chakra-ui/react'
import Navbar from './components/Navbar'
import '@fontsource/roboto'
import '@fontsource/roboto/700.css'
import '@fontsource/roboto/900.css'
import '@fontsource/roboto/300.css'
import '@fontsource/roboto/100.css'
// import '@fontsource/nunito-sans';
import '@fontsource/nunito-sans/900.css'
import '@fontsource/nunito-sans/800.css'
import '@fontsource/nunito-sans/600.css'
import { theme } from './theme'
import Results from './components/Results'
import {
  attributes,
  maxAttributeImportance,
  themeIndustryPerformance,
} from './attributes'
import { groupBy, mapValues, meanBy } from 'lodash'
import PerformanceScoringTable from './components/PerformanceScoringTable'
import Footer from './components/Footer'

function App() {
  const [scores, setScores] = React.useState(
    Object.fromEntries(
      attributes.map(a => [
        a.statement,
        {
          score: Math.round(a.industryScore),
          // score: 75,
          theme: a.theme,
          statement: a.statement,
        },
      ])
    )
  )
  const [results, setResults] = React.useState(
    mapValues(themeIndustryPerformance, Math.round)
  )
  const calculateResult = scores =>
    mapValues(groupBy(scores, 'theme'), statements =>
      // Math.round(meanBy(statements, 'score'))
      meanBy(statements, 'score')
    )
  const handleScoreChange = (statement, value) => {
    const newScores = {
      ...scores,
      [statement]: { ...scores[statement], score: value },
    }
    const newResults = calculateResult(newScores)
    setResults(newResults)
    setScores(newScores)
  }

  // const actionItems = attributesOfImportantThemes
  //   .filter(({ theme }) => results[theme] < medianThemePerformance)
  const actionItems = attributes
    //   .filter(({ theme }) => results[theme] < medianThemePerformance)
    // .filter(
    //   ({ stdScore, statement }) =>
    //     attributes.find(a => a.statement === statement).industryScore +
    //       0.674 * stdScore >
    //     scores[statement].score
    // )
    .map(({ statement, importance, stdScore, theme }) => ({
      statement,
      importance,
      // stdScore,
      theme,
      score: scores[statement].score,
      // stdDevOfScore:
      //   (scores[statement].score -
      //     attributes.find(a => a.statement === statement).industryScore) /
      //   stdScore,
      impact:
        100 *
        ((((100 - scores[statement].score) / 100) * importance) /
          maxAttributeImportance),
    }))
    .sort((a, b) => b.impact - a.impact)
  // .slice(0, 3)
  console.log({ attributeImpactScores: actionItems })

  return (
    <ChakraProvider theme={theme}>
      <Navbar />
      <Box maxW={'container.xl'} mx={'auto'} p={12}>
        <Box
          sx={{
            '@media print': {
              pageBreakAfter: 'always',
            },
          }}
        >
          <Box w={'full'} my={9}>
            <Stack spacing={12}>
              <Text fontSize={'3xl'} color="gray.700" px={4} textAlign={'left'}>
                Please rate your company on how well it performs when customers
                get information, make a purchase, or resolve an issue.
                {/*Please rate your company on how well it performs on the*/}
                {/*following specific characteristics when customers interact with*/}
                {/*your company to get information, make a purchase, or resolve an*/}
                {/*issue.*/}
              </Text>
              <PerformanceScoringTable
                handleScoreChange={handleScoreChange}
                scores={scores}
              />
            </Stack>
          </Box>
        </Box>
        {/*<Divider w={'full'} />*/}
        <Results actionItems={actionItems} results={results} />
      </Box>
      <Footer />
      {/*</Text>*/}
      {/*</Box>*/}
    </ChakraProvider>
  )
}

export default App
